import Vue from 'vue'
import Vuetify, {
  VApp,
  VAppBar,
  VAppBarTitle,
  VAppBarNavIcon,
  VTooltip,
  VSpacer,
  VMenu,
  VList,
  VListItem,
  VListItemIcon,
  VListItemTitle,
  VListItemContent,
  VListGroup,
  VIcon,
  VCard,
  VCardTitle,
  VCardSubtitle,
  VCardText,
  VCardActions,
  //VCarousel,
  //VCarouselItem,
  //VRating,
  VToolbar,
  VToolbarTitle,
  VBtn,
  VNavigationDrawer,
  VDivider,
  VMain,
  //VParallax,
  VContainer,
  VResponsive,
  VRow,
  VCol,
  VImg,
  //VBadge,
  VForm,
  VTextField,
  VTextarea,
  VFooter,
  VBottomSheet,
  VSheet,
  //VChip,
  VProgressCircular,
  VAlert,
  VBreadcrumbs,
  VBreadcrumbsItem,
  VSwitch,
  VTabs,
  VTab,
  VTabItem,
  //VCheckbox,
  VDataTable,
  VSnackbar,
  VSpeedDial,
  VSubheader,
  VDialog,
  //VEditDialog,
  VSelect,
  //VColorPicker,
  //VAutocomplete,
  VSimpleTable,
  VProgressLinear,
  //VSlideGroup,
  //VSlideItem,
  VAvatar,
  VListItemAvatar,
  VListItemSubtitle,
  //VFabTransition,
  VFlex
} from 'vuetify/lib'
import { Ripple, Resize } from 'vuetify/lib/directives'
import ptbr from 'vuetify/src/locale/pt.ts'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAppBar,
    VAppBarTitle,
    VAppBarNavIcon,
    VTooltip,
    VSpacer,
    VMenu,
    VList,
    VListItem,
    VListItemIcon,
    VListItemTitle,
    VListItemContent,
    VListGroup,
    VIcon,
    VCard,
    VCardTitle,
    VCardSubtitle,
    VCardText,
    VCardActions,
    //VCarousel,
    //VCarouselItem,
    //VRating,
    VToolbar,
    VToolbarTitle,
    VBtn,
    VNavigationDrawer,
    VDivider,
    VMain,
    //VParallax,
    VContainer,
    VResponsive,
    VRow,
    VCol,
    VImg,
    //VBadge,
    VForm,
    VTextField,
    VTextarea,
    VFooter,
    VBottomSheet,
    VSheet,
    //VChip,
    VProgressCircular,
    VAlert,
    VBreadcrumbs,
    VBreadcrumbsItem,
    VSwitch,
    VTabs,
    VTab,
    VTabItem,
    //VCheckbox,
    VDataTable,
    VSnackbar,
    VSpeedDial,
    VSubheader,
    VDialog,
    //VEditDialog,
    VSelect,
    //VColorPicker,
    //VAutocomplete,
    VSimpleTable,
    VProgressLinear,
    //VSlideGroup,
    //VSlideItem,
    VAvatar,
    VListItemAvatar,
    VListItemSubtitle,
    //VFabTransition,
    VFlex
  },
  directives: {
    Ripple,
    Resize
  }
})

export default new Vuetify({
  lang: {
    locales: { ptbr },
    current: 'ptbr'
  }
})
